
import Vue from 'vue'
import SVGIcon from '@/components/svgIcon/index.vue'
import { faEye, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { mapGetters } from 'vuex';
import { ELoginStatus } from '@/store/user';
import { LoginApi } from '@/api';

export default Vue.extend({
	data() {
		return {
			formData: {
				username: "admin",
				password: '123456',
				captcha: ""
			},
			showpassword: false,
			// loading: false
			captchaSrc: '',
			captchaControl: {
				src: '',
				loading: false
			}

		}
	},
	created() {
		this.initCaptch()
	},
	methods: {
		handleLogin() {
			// console.log(this.formData);
			this.$store.dispatch('userStore/login', this.formData).then(v => {
				// console.log(this.loginStatus);

				if (this.loginStatus === ELoginStatus.logined) {
					this.$router.push({
						name: this.$route.params?.name || 'home'
					})
				}

			}).catch(v => {
				console.log(v, this.loginStatus);

			})
		},
		changePasswordShow() {
			this.showpassword = !this.showpassword
		},
		initCaptch() {
			if (this.captchaControl.loading) {
				return
			}
			this.captchaControl.loading = true
			LoginApi.getCaptcha().then(v => {
				this.captchaControl.src = URL.createObjectURL(new Blob([Buffer.from(v.data)], { type: 'image/svg+xml' }))
			}).finally(() => {
				this.captchaControl.loading = false
			})
		}
	},
	components: {
		SVGIcon
	},
	computed: {
		user: () => faUser,
		password: () => faLock,
		showpassIcon: () => faEye,
		hidepassIcon: () => faEyeSlash,
		passwordIcon(): any {
			return this.showpassword ? this.showpassIcon : this.hidepassIcon
		},
		...mapGetters({
			loading: 'userStore/isLogin',
			loginStatus: 'userStore/loginStatus'
		}) as {
			loading: () => boolean,
			loginStatus: () => ELoginStatus
		}
	}

})
